import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

/**
 * Opens the dialog for the manageapp design-system preview: stand-in subscription data, and a Confirm
 * button that closes instead of charging. Bypasses openChangePlanModal because the preview must reach
 * the redesigned dialog regardless of the feature flag, and must never land on the classic one.
 */
export const openChangePlanModalV2Preview = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CHANGE_PLAN_MODAL_V2,
      panelProps: {isPreview: true},
    })
  );
};
